//frontend/src/pages/auth/ForgotPassword.jsx
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { loginSettingsAPI, authAPI } from '../../services/api';
import '../../assets/styles/login.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [logoUrl, setLogoUrl] = useState('/logo.png');
  
  // Not Primary Modal
  const [showNotPrimaryModal, setShowNotPrimaryModal] = useState(false);
  const [companyName, setCompanyName] = useState('');

  // Fetch logo
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await loginSettingsAPI.getLoginSettings();
        if (response.success && response.data?.logoUrl) {
          let logo = response.data.logoUrl;
          if (typeof logo === 'string' && logo.startsWith('"')) {
            try { logo = JSON.parse(logo); } catch (e) {}
          }
          setLogoUrl(logo);
        }
      } catch (error) {
        console.error('Failed to fetch settings:', error);
      }
    };
    fetchSettings();
  }, []);

  const getLogoSrc = () => {
    if (!logoUrl) return '/logo.png';
    if (logoUrl.startsWith('http')) return logoUrl;
    if (logoUrl.startsWith('/uploads')) {
      const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1';
      return `${apiUrl.replace('/api/v1', '')}${logoUrl}`;
    }
    return logoUrl;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!email.trim()) {
      setError('И-мэйл хаяг оруулна уу');
      return;
    }
    
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('И-мэйл хаяг буруу байна');
      return;
    }
    
    setLoading(true);
    
    try {
      const response = await authAPI.forgotPassword(email);
      
      if (response.data.success) {
        // Амжилттай - ResetPassword хуудас руу шилжих
        navigate('/reset-password', { 
          state: { email: email }
        });
      }
    } catch (err) {
      console.error('Forgot password error:', err);
      
      const message = err.response?.data?.message;
      
      // Primary админ биш бол modal харуулах
      if (message === 'not_primary') {
        setCompanyName(err.response?.data?.company_name || 'Компани');
        setShowNotPrimaryModal(true);
      } else {
        setError(message || 'Алдаа гарлаа');
      }
    } finally {
      setLoading(false);
    }
  };

  // Not Primary Admin Modal
  const NotPrimaryModal = () => (
    <div className="forgot-modal-overlay">
      <div className="forgot-modal">
        <div className="forgot-modal-icon warning">⚠️</div>
        <h2 className="forgot-modal-title">Нууц үг сэргээх боломжгүй</h2>
        <p className="forgot-modal-text">
          Таны аккаунт <strong>{companyName}</strong> компанийн үндсэн админ биш байна.
        </p>
        <p className="forgot-modal-text">
          Нууц үг сэргээхийн тулд компанийн админтай холбогдоно уу.
        </p>
        <button 
          onClick={() => setShowNotPrimaryModal(false)} 
          className="forgot-modal-btn"
        >
          Ойлголоо
        </button>
      </div>
    </div>
  );

  return (
    <div className="login-container forgot-container">
      {showNotPrimaryModal && <NotPrimaryModal />}
      
      {/* Left Side - Blue */}
      <div className="forgot-left">
        <div className="forgot-circle circle-1"></div>
        <div className="forgot-circle circle-2"></div>
        <div className="forgot-circle circle-3"></div>
        
        <div className="forgot-left-content">
          <div className="forgot-icon">🔐</div>
          <h2>Нууц үг сэргээх</h2>
          <p>Бүртгэлтэй и-мэйл хаягаар баталгаажуулах код илгээгдэнэ</p>
        </div>
      </div>
      
      {/* Right Side - Form */}
      <div className="login-form-section">
        <div className="login-form-container">
          {/* Header */}
          <div className="form-header">
            <div className="form-header-logo">
              <img src={getLogoSrc()} alt="Logo" />
            </div>
            <h1 className="form-title">Нууц үг мартсан?</h1>
            <p className="form-subtitle">
              Бүртгэлтэй и-мэйл хаягаа оруулна уу
            </p>
          </div>
          
          {/* Error */}
          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              <div className="error-content">
                <p>{error}</p>
              </div>
            </div>
          )}
          
          {/* Form */}
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label className="input-label" htmlFor="email">
                И-мэйл хаяг
              </label>
              <div className="input-wrapper">
                <span className="input-icon">✉️</span>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="info@company.mn"
                  className="login-input"
                  autoFocus
                />
              </div>
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="login-btn"
            >
              <span className="login-btn-content">
                {loading ? (
                  <>
                    <span className="spinner"></span>
                    Илгээж байна...
                  </>
                ) : (
                  <>
                    <span>📧</span>
                    Код илгээх
                  </>
                )}
              </span>
            </button>
          </form>
          
          {/* Back to Login */}
          <div className="register-row">
            <Link to="/login" className="back-to-login">
              ← Нэвтрэх хуудас руу буцах
            </Link>
          </div>
          
          {/* Footer */}
          <div className="login-footer">
            <p>© {new Date().getFullYear()} Pingo Express</p>
            <p className="developed-by">
              Developed by{' '}
              <a href="mailto:info@prolink.mn" className="prolink-link">
                Prolink Team
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;